module.exports = __webpack_public_path__ + "static/media/ResearchConnect_2.246a518a.png";